/**
 * Event content viewer component
 */
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges
} from '@angular/core';
import {AgregationService} from '@ispm-client/modules/aggregator/services/aggregator.service';
import {DynamicModalLoaderService} from '@ispm/layout/services/dynamic-modal-loader.service';
import {EventService} from '@ispm-client/modules/events/services/event.service';
import {IEvent, IEventDefinition, IEventManagerConfig, IEventMapParam} from '../../Interfaces/index';
import {Widget} from '@ispm/widgets/decorator/widget.decorator';
import {IWidgetItem} from '@ispm/widgets/interfaces/widget-item.interface';
import {cloneDeep, find, get, has, isEmpty, isEqual, merge, omit, remove, set} from 'lodash';
import {ICloseReturnType, PlaceholderChildComponent} from '@ispm/layout/classes/placeholder-child-component.abstract';
import {modalResponse} from '@ispm/layout/constants/modal-responses.enum';
import {InterpolateService} from '@ispm/shared/services/interpolate.service';
import {RouterManagerService} from '@ispm/core/services/router-manager.service';
import {FlattenService} from '@ispm-client/modules/aggregator/services';
import {CORE_ACTIONS} from '@ispm/core/constants/core-actions.constant';
import {Store} from '@ngrx/store';
import {IgenomicsState} from '@ispm/core/interfaces/genomics-state.interface';
import {ModalLoaderNgjsService} from '@ispm/layout/services/modal-loader-ngjs.service';
import {ConfirmModalLoaderPayload} from '@ispm/layout/classes/confirm-modal-loader-payload';
import {map, take, takeUntil} from 'rxjs/operators';
import {IDiagnosticOrder} from "@ispm/test/interfaces/diagnostic-order.interface";
import {TranslateService} from "@ngx-translate/core";
import {NOTIFICATION_MESSAGE} from "@ispm-client/modules/aggregator/services/consts";
import {EventValidationWizardService} from '../../services/event-validation-wizard.service';
import {Subscription} from 'rxjs/Subscription';
import {zip} from "rxjs";
import {OrderService} from "@ispm-client/modules/orders/services/order.service";
import {Subject} from 'rxjs/Rx';
import {NotificationMessageService} from '@ispm/core/components/customise-notification/notifications-message.service';
import {Router} from "@angular/router";
import {SessionStorageService} from '@ispm/shared/services/session-storage.service'


@Component({
  selector: 'ispm-event-content-viewer',
  templateUrl: './event-content-viewer.component.html',
  styleUrls: ['./event.content-viewer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
@Widget('EventContentViewer')
export class EventContentViewerComponent extends PlaceholderChildComponent implements OnInit, IWidgetItem, OnChanges {
  @Input() _selectedEvent: IEvent;
  @Input() eventsDefinitions: Map<string, IEventDefinition>;
  @Input() config: IEventManagerConfig;
  @Input() isEditable: boolean = false;
  @Input() events: Array<IEvent>;
  @Input() showLaunchPacsInEventContent: boolean = true;
  public ModalLoaderTunnelName: string = EventService.ModalLoaderTunnelName;
  public submitted: boolean = false;
  load: boolean = true;
  eventContentData;
  eventFileIdList: Array<string>;
  eventFormData: Array<any>;
  eventFormConfigs: Array<any>;
  eventDefinition: IEventDefinition;
  isApproveAvailable: boolean = true;
  isCopyToTumourAvailable: boolean = false;
  enableSaveButton: boolean = false;
  eventFormPayload: any;
  isBackToDashboardAvailable: boolean = true;
  isValidateAvailable: boolean = true;
  isSelectEventAvailable: boolean = false;
  showCopyToResource: boolean = true;
  showDataCaptureSection: boolean = true;
  addReportAvailable: boolean = true;
  showUpdateButton: boolean = false;
  isCopied: boolean = false;
  isEventViewerEditable: boolean = false;
  eventFormKeyMap = new Map();
  invokeSubs: Subscription;
  checkboxIcon: string = 'icon__Checkmark1';
  showWarningEnable: boolean = false;
  private destroyer: Subject<any> = new Subject();
  private showWizard = true;
  private dashboardUrl: string;
  private eventMapParam: IEventMapParam = {
    eventBasedOnDataChange : false
  }
  @Output() onChangeDataEvent: EventEmitter<boolean> = new EventEmitter();
  @Output() onUpdateDataEvent: EventEmitter<boolean> = new EventEmitter();
  /**
   * set event data
   * @param widgetData
   */
  set widgetData(widgetData: any) {

  }

  /**
   * set event config
   * @param config
   */
  set widgetConfig(config: any) {
    this.eventContentData = get(config.widgetPayload, 'data.content');
    this.prepareContentData();
  }

  /**
   * set event id
   * @param event
   */
  @Input()
  set selectedEvent(event) {
    this.isApproveAvailable = false;
    this.enableSaveButton = false;
    this.isCopyToTumourAvailable = false;
    if (event && !get(event, 'archived')) {
      this._selectedEvent = event;
      this.eventContentData = get(this._selectedEvent, 'content');
      this.showCopyToResource = get(this.config, 'showCopyToResource', true)
      this.showUpdateButton = get(this.config, 'showUpdateButton', false);
      this.showDataCaptureSection = get(this.config, 'showDataCaptureSection', true);
      this.checkboxIcon = 'icon__Checkmark1';
      if(get(this.config, 'showAddReportButton') === false) {
        this.addReportAvailable = false;
      }
      this.prepareContentData();
    } else {
      this._selectedEvent = null;
    }
  }

  @Input()
  set eventSelection (eventSelection: any) {
    let currentSelectedEvent = get(eventSelection, 'event');
    set(currentSelectedEvent, 'selected', get(eventSelection, 'selection'));
    if(get(currentSelectedEvent, 'id') === get(this._selectedEvent, 'id')){
      set(this._selectedEvent, 'selected', get(eventSelection, 'selection'));
      this.onUpdateFormData();
    } else {
      this.verifyEventSelection(currentSelectedEvent);
    }
  }
  beforeClose(_modalResponse?: modalResponse): void | ICloseReturnType {
    return true;
  }

  constructor(private _agregationService: AgregationService,
              private modalLoader: DynamicModalLoaderService,
              private _modalLoaderService: ModalLoaderNgjsService,
              private _eventService: EventService,
              private notificationMessageService: NotificationMessageService,
              private notificationMessage: NOTIFICATION_MESSAGE,
              private changeDetector: ChangeDetectorRef,
              private interpolateService: InterpolateService,
              private _flattenService: FlattenService,
              private _translate: TranslateService,
              private _store: Store<IgenomicsState>,
              private eventWizardService: EventValidationWizardService,
              private _orderService: OrderService,
              private router: Router,
              private routerManagerService: RouterManagerService) {
    super();
    this.dashboardUrl = sessionStorage.getItem(SessionStorageService.PREV_DASHBOARD_URL);
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (this._selectedEvent){
      this.isApproveAvailable = this.isEditable && !this._selectedEvent.approved;
      this.isCopyToTumourAvailable = !this.isApproveAvailable;
      this.isSelectEventAvailable = this.isEditable && !this._selectedEvent.selected && get(this.config, 'showEventSelection', false);
      const hasEventViewer = has(this.eventDefinition, 'ui.isEventViewerEditable');
      this.isEventViewerEditable = hasEventViewer ? get(this.eventDefinition, 'ui.isEventViewerEditable') : this.isEditable;
    }
  }

  ngOnInit() {
    if (get(this.config, 'showClose') === false) {
      this.isBackToDashboardAvailable = false;
    }
    if (get(this.config, 'showValidate') === false) {
      this.isValidateAvailable = false;
    }
    this.prepareContentData();

    this.invokeSubs = this.eventWizardService.getEvent().pipe(
      takeUntil(this.destroyer.asObservable())
    ).subscribe(() =>{
      this.prepareEventToUpdateFormData();
    })
    this.isCopied = false;
  }

  /**
   * set event content data to display
   */
  prepareContentData() {
    if (this.eventsDefinitions && this._selectedEvent) {
      this.eventDefinition = this.eventsDefinitions.get(this._selectedEvent.category.code);
      if (!this.eventDefinition) {
        this.eventDefinition = this.eventsDefinitions.get('default');
      }
      const refObj = { };
      this.eventContentData.forEach((e) => {
        (refObj[e.contentType] ? refObj[e.contentType].push(e) : (refObj[e.contentType] = [e]));
      });
      this.eventFormData = cloneDeep(refObj['form']);
      this.eventFormData = this.eventFormData ? cloneDeep(this.eventFormData.concat(refObj['link'])) : cloneDeep(refObj['link']);
      this.eventFileIdList=refObj['file'];

      this.eventContentData.forEach((e) => {
        if(e.resourceType==="DICOM"){
          if(!this.eventFileIdList)
            this.eventFileIdList=[];
          this.eventFileIdList = [].concat(this.eventFileIdList,[e]);
        }
      });
      this.eventFormConfigs = [];
      if (this.eventDefinition && this.eventDefinition.ui && this.eventDefinition.ui.formsConfig) {
        this.eventFormConfigs = cloneDeep(this.eventDefinition.ui.formsConfig);
      } else if (this.eventDefinition && this.eventDefinition.common && this.eventDefinition.common.formsConfig) {
        this.eventFormConfigs = cloneDeep(this.eventDefinition.common.formsConfig);
      }
    }
    const enableSaveButtonBasedOnDataChange = "enableSaveButtonBasedOnDataChange";
    let saveButtonExclusionFields:Array<string> =[];
    let saveButtonSortOrder:Array<string> =[];
    let associationKey: string;
    let modificationKey: string;
    if(has(this.eventDefinition, ["ui",enableSaveButtonBasedOnDataChange])){


      if(has(this.eventDefinition, ["ui",enableSaveButtonBasedOnDataChange, "exclusionFields"])){
        saveButtonExclusionFields = get(this.eventDefinition, ["ui", enableSaveButtonBasedOnDataChange, "exclusionFields"]);
      }
      if(has(this.eventDefinition, ["ui",enableSaveButtonBasedOnDataChange, "sortOrder"])){
        saveButtonSortOrder = get(this.eventDefinition, ["ui", enableSaveButtonBasedOnDataChange, "sortOrder"]);
      }
      if(has(this.eventDefinition, ["ui",enableSaveButtonBasedOnDataChange, "groupMapping"])){
        associationKey = get(this.eventDefinition, ["ui", enableSaveButtonBasedOnDataChange, "groupMapping", "associationKey"]);
        modificationKey = get(this.eventDefinition, ["ui", enableSaveButtonBasedOnDataChange, "groupMapping", "modificationKey"]);
      }
      this.eventMapParam = {
        eventBasedOnDataChange : true,
        exclusionKeys: saveButtonExclusionFields,
        sortOrder: saveButtonSortOrder,
        groupMapping :{
          associationKey : associationKey,
          modificationKey: modificationKey
        }
      }
    }

    this.performEventMapping();
    this.changeDetector.markForCheck();
    this.changeDetector.detectChanges();
  }

  /**
   * Close reports view and navigate back to dashboard
   */
  onCloseReports() {
    if (this.enableSaveButton) {
      this._modalLoaderService.popupModal('confirm',
        ConfirmModalLoaderPayload.builder()
          .setTitle(this._translate.instant('Save Data') || 'Save Data')
          .setContent(this._translate.instant('UN_SAVED_CHANGES') || 'Unsaved changes have been made to current event. Would you like to save data?.')
          .setDeclineButtonText('No')
          .setApproveButtonText('Yes'),
        'ALERT').subscribe(response => {
        if (get(response, 'payload') === modalResponse.approve) {
          this.onUpdateFormData();
        } else {
          if(this.dashboardUrl) {
            this.routerManagerService.back();
          } else {
            window.history.back(); // FIXME: window should be extracted into a service
          }
          this._agregationService.clearQueriesData();
        }
      });
    } else {
      this._store.dispatch({
        type: CORE_ACTIONS.SET_LOADER,
        payload: true
      });

      if(this.dashboardUrl) {
        this.routerManagerService.back();
      } else {
        window.history.back(); // FIXME: window should be extracted into a service
      }
      this._agregationService.clearQueriesData();
    }

    // this._agregationService.clearQueriesData();
    // TODO histroy back will clear all the data in store so some other way of going back
  }

  goToState(redirectUrl, param = { }) {
    const interpolatedParamsFromUrl = this.interpolateService.interpolate(redirectUrl, param);
    const redirectUrlState = this.routerManagerService.urlToState(interpolatedParamsFromUrl);
    this.router.navigate(redirectUrlState.name, redirectUrlState.params);
  }

  /**
   * On approving event or show the popup warning if order already exist
   */
   onApproveEvent() {
    if (!get(this._selectedEvent, 'approved') && !isEmpty(get(this.config, 'orderInformationPopup'))) {
      this._orderService.checkForOrder(this.config, this._selectedEvent).pipe(
        takeUntil(this.destroyer.asObservable())
      ).subscribe( data => {
        if(!isEmpty(data)) {
          if (get(data, 'orderExist')) {
            this.popupWarningForOrderExist(get(data, 'popupDetails'));
          } else {
            this.validateEvent();
          }
        }
      });
    } else if (!get(this._selectedEvent, 'approved')){
       this.validateEvent();
    }
  }

  /**
   * Update the event with approved flag true
   */
  validateEvent() {
    set(this._selectedEvent, 'approved', true);
    this._eventService.updateEvent(this._selectedEvent.id, this._selectedEvent).subscribe(data => {
      this.notificationMessageService.success(this.notificationMessage.EVENT_APPROVED_SUCCESSFULLY);
    });
  }

  /**
   *  Method for the popup warning if order already exist
   */
  popupWarningForOrderExist(popupDetails) {
    if (!this.showWarningEnable) {
      this.showWarningEnable = true;
      const warningMessage = get(popupDetails, 'warningMessage');
      const warningTitle = get(popupDetails, 'warningTitle');
      this._modalLoaderService.popupModal('confirm',
        ConfirmModalLoaderPayload.builder()
          .setTitle(`${warningTitle}`)
          .setContent(`${warningMessage}`)
          .setApproveButtonText('Ok'),
        'ALERT'
      ).subscribe(response => {
        this.showWarningEnable = false;
        set(this._selectedEvent, 'approved', false);
        this.isApproveAvailable = false;
        this.checkboxIcon = '';
      });
    }
  }

  /**
   * Method to check data modified based the current form data versus data in the store.
   */
  private dataModificationCheck(){
    if(this.eventFormPayload.length === 1){
      const currentEventData = cloneDeep(this.eventFormPayload[0].data);

      const firstKey = Object.keys(currentEventData)[0];
      const currentFormData = get(currentEventData, firstKey)

      let dataModified: boolean = false;
      currentFormData.forEach(modifiedFormData =>{
        const firstKey = Object.keys(modifiedFormData)[0];
        const eventFormData = JSON.stringify(this.eventFormKeyMap.get(firstKey));
        let currentFormDataReceived = [];
        if(has(modifiedFormData[firstKey], "content")){
          currentFormDataReceived = get(modifiedFormData[firstKey], "content");
        }else{
          currentFormDataReceived = modifiedFormData[firstKey];
        }
        if(currentFormDataReceived !== undefined){
          if(Array.isArray(currentFormDataReceived)){
            this._eventService.deleteBlankNullValuesForArrays(currentFormDataReceived,
              this.eventMapParam.exclusionKeys);
          }else{
            this._eventService.deleteBlankNullValues(currentFormDataReceived,
              this.eventMapParam.exclusionKeys);
          }
        }
        let currentFormDataString:string = "";
        let formDataArray: Array<any> = [];
        if(currentFormDataReceived !== undefined && !Array.isArray(currentFormDataReceived)){
          formDataArray.push(currentFormDataReceived);
          currentFormDataString = JSON.stringify(formDataArray);
        }else{
          currentFormDataString = JSON.stringify(currentFormDataReceived);
        }
        const dataIsEqual:boolean = isEqual(currentFormDataString, eventFormData);
        if(!dataIsEqual){
          dataModified = true;
        }

      });
      this.enableSaveButton = dataModified;

    }else{
      this.handleEventContentArray();
    }
  }

  private handleEventContentArray() {
    let currentActiveKey: string = "";
    let formDataArray: Array<any> = [];
    const formData = cloneDeep(this.eventFormPayload);
    if(Array.isArray(formData)){
      formData.forEach((data, index) => {
        if(has(data,"formKey") ){
          const currentKey  =  data.formKey
          const dataElement = data.data;
          let dataObject = dataElement[currentKey];
          if(Array.isArray(dataObject)){
             dataObject.forEach((currentData) => {
              this._eventService.deleteBlankNullValues(currentData,
                this.eventMapParam.exclusionKeys);
              formDataArray.push(currentData);
            });
            currentActiveKey = currentKey;
          }
          else if(dataObject !== null && dataObject !== undefined){
            this._eventService.deleteBlankNullValues(dataObject,
              this.eventMapParam.exclusionKeys);
            formDataArray.push(dataObject);
            currentActiveKey = currentKey;
          }

        }
      });
    }
    const dataIsEqual:boolean = this._eventService.arrayEquals(formDataArray, this.eventFormKeyMap.get(currentActiveKey));
    if(dataIsEqual){
      this.enableSaveButton = false;
    }else{
      this.enableSaveButton = true;
    }
  }

  /**
   * Perform event mapping for selected event.
   */
  private performEventMapping(){
    if(this.eventMapParam.eventBasedOnDataChange) {

      this.eventFormKeyMap = this._eventService.selectedEventMap(this.eventMapParam, cloneDeep(this._selectedEvent),
         );
    }
  }

  /**
   * Event FormData Updated
   */
  formDataUpdated(formPayload: any) {
   this.eventFormPayload = get(formPayload, 'payload');
   const hasUpdatedFields = this.enableSaveButton = get(formPayload, 'hasUpdatedFields');
    if(hasUpdatedFields === true && this.eventMapParam.eventBasedOnDataChange){
      this.dataModificationCheck();
    }else{
        this.enableSaveButton = hasUpdatedFields;
    }
    this.onChangeDataEvent.emit(this.enableSaveButton);
  }

  /**
   * Flatten Content Data
   */
  flattenContent() {
    if(!this.eventFormPayload) {
      return;
    }
    const updatedEventFormPayload: Array<any> = [];
    // Remove all the items whose updatedFields is empty
    remove(this.eventFormPayload, item => {
        return !item['updatedFields'] || !(item['updatedFields'] && item['updatedFields'].length > 0);
      });
    const eventFormPayloadCopy = cloneDeep(this.eventFormPayload);
    for (const item of eventFormPayloadCopy) {
      if (item.updatedFields.length) {
        const formConfig = find(this.eventFormConfigs,  ['key',  get(item, 'formKey')]);
        const formIdOrFormConfig = formConfig['formId'] ? formConfig['formId'] : formConfig['formConfig'];
          this._flattenService.flatten(formIdOrFormConfig, item['data'], item.updatedFields).pipe(
            takeUntil(this.destroyer.asObservable())
          ).subscribe((flattenData) => {
            if (flattenData.length) {
              for (const flattenDataItem of flattenData) {
                for (const formDataItem of flattenDataItem.formData) {
                  if (!isEmpty(formDataItem)) {
                    delete formDataItem['_dataBindingIdentifier'];
                    const tempData = {
                      data: omit(formDataItem, 'key'),
                      contentType: get(formDataItem, 'key') === 'links' ? 'link' : 'form',
                      formKey: get(formDataItem, 'key')
                    };

                    if (!isEmpty(get(formDataItem, 'id'))) {
                      tempData['id'] = get(formDataItem, 'id');
                      tempData['resourceType'] = get(formDataItem, 'resourceType');
                      delete tempData.data.id;
                    }
                    updatedEventFormPayload.push(tempData);
                    if (get(formDataItem, 'key') === 'eventInfo') {
                      merge(this._selectedEvent, formDataItem);
                    }
                  }
                }
              }
              remove(this.eventFormPayload, payloadItem => {
                return get(payloadItem, 'formKey') === get(item, 'formKey');
              });
            }
          });
        // }
      }
    }
    if (updatedEventFormPayload.length) {
      this.eventFormPayload = this.eventFormPayload.concat(updatedEventFormPayload);
    }
  }

  /**
   * Update Event content formdata
   */
  onUpdateFormData() {
    const postEvent = this.prepareEventToUpdateFormData();
    if(postEvent) {
      this._eventService.updateEvent(postEvent.id, postEvent).subscribe(data => {
          this._selectedEvent = data;
          this.onUpdateDataEvent.emit(true);
          this.notificationMessageService.success(this.notificationMessage.EVENT_DATA_UPDATED_SUCCESSFULLY);
          this.enableSaveButton = false;
        },
        error => {
          this._store.dispatch({
            type: CORE_ACTIONS.SET_LOADER,
            payload: false
          });
          this.notificationMessageService.error(this.notificationMessage.FAILED_TO_UPDATE_EVENT_DATA);
        });
    }
  }

  /**
   * Copy approved data to respective resource
   */
  onCopyToResource() {
    this.verifyLatestEventAndRaiseWarning();

  }

  /**
   * Checks for the latest event with respect to type of the selected event .
   * @param {IEvent[]} events
   * @returns {boolean}
   */
  isLatestEventExist(events :IEvent[]){
    const latestEvents = events.filter(eventItem => new Date(get(eventItem,'date','')) > new Date(get(this._selectedEvent,'date','')));
    return latestEvents.length > 0;
  }


  /**
   * This verifies the if there is any latest event present than the current selected event,the confirm event copy alert will be raised
   * and on action the event are map are resources.
   */
  verifyLatestEventAndRaiseWarning(){
    let currentSelectedEvent = this._selectedEvent;
    this._eventService.getAllEvents().pipe(
      take(1),
      map(eventMap =>{
        return eventMap.valueSeq().toArray().filter(eventItem =>
          get(currentSelectedEvent,'group.code') === get(eventItem, 'group.code') &&
          get(currentSelectedEvent,'id') !== get(eventItem, 'id'))

      })
    ).subscribe( events => {
      if (this.isLatestEventExist(events)) {
        this.confirmEventCopy().pipe(
          takeUntil(this.destroyer.asObservable())
        ).subscribe(response => {
          if (get(response, 'payload') === modalResponse.approve) {
            this.mapEventToResources();
          }
        });
      } else {
        this.mapEventToResources();
      }
    })


  }

  confirmEventCopy(){
    return this._modalLoaderService.popupModal('confirm',
      ConfirmModalLoaderPayload.builder()
        .setTitle('Event Copy Warning')
        .setContent('This is not the latest event of this type, are you sure you want to copy this event to the dashboard.')
        .setCssClasses('bubble-warning')
        .setDeclineButtonText('No')
        .setApproveButtonText('Yes'),
         'ALERT',
         this.ModalLoaderTunnelName)
  }

  /**
   * Maps the event data  to the respective resources as per  the event definition .
   */
  mapEventToResources(){
    if(!this.isCopied) {
      this.isCopied = true;
      this._eventService.mapToResource({ eventId: get(this._selectedEvent, 'id')}).subscribe(resp => {
          this.notificationMessageService.info(this.notificationMessage.COPIED_EVENT_DATA_TO_RESPECTIVE_SOURCE);
          this._eventService.setSelectedEvent(resp);
          this._store.dispatch({
            type: CORE_ACTIONS.SET_LOADER,
            payload: false
          });
          this.isCopied = false;
        },
        error => {
          this._store.dispatch({
            type: CORE_ACTIONS.SET_LOADER,
            payload: false
          });
          this.notificationMessageService.error(this.notificationMessage.FAILED_TO_COPY_EVENT_DATA_TO_RESPECTIVE_SOURCE);
          this.isCopied = false;
        });
    }
  }

  /**
   * Save, Validate and copy to respective data model
   */
  onUpdateValidateCopyFormData() {
    let isEventSelected = get(this._selectedEvent, 'selected');
    isEventSelected = isEventSelected && get(this.config, 'showEventSelection')
    const postEvent = this.prepareEventToUpdateFormData();
    postEvent['approved'] = true;

    if (!isEventSelected && (this.events && this.events.length > 1)) {
      this._modalLoaderService.popupModal('confirm',
        ConfirmModalLoaderPayload.builder()
          .setTitle('Report not associated to order')
          .setContent('Do you want to associate this report to the order?')
          .setDeclineButtonText('No')
          .setApproveButtonText('Yes'),
        'ALERT',
        this.ModalLoaderTunnelName).subscribe(response => {
        if (get(response, 'payload') === modalResponse.approve) {
          postEvent['selected'] = true;
          let previousSelectedEvent = find(this.events, event => event['selected']);
          this.selectEventAndUpdate(postEvent, isEventSelected, previousSelectedEvent);
        } else {
          this.selectEventAndUpdate(postEvent, isEventSelected, null);
        }
      });
      return;
    } else {
      isEventSelected = this.events && this.events.length > 1 ? isEventSelected : true;
      this.selectEventAndUpdate(postEvent, isEventSelected, null);
    }
  }

  /**
   * Associate event and update event data
   * @param postEvent
   * @param isEventSelected
   */
  async selectEventAndUpdate(postEvent, isEventSelected, previousSelectedEvent) {
    if (isEventSelected) {
      postEvent['selected'] = true;
    }
    if (get(this.config, 'includeDiagnosticOrderContext', false)) {
      const postEventContentArray: any[] = get(postEvent, 'content', []);
      let formConfigArray: any[] = get(this.eventDefinition, 'common.formsConfig', []);
      if (!isEmpty(postEventContentArray) && !isEmpty(formConfigArray)) {
        const diagnosticOrder: IDiagnosticOrder = await this._eventService.getDiagnosticOrderFromStore();
        postEventContentArray.filter(item => {
          formConfigArray = formConfigArray
            .filter(formConfigItem => get(formConfigItem, 'includeDiagnosticOrderContext', false)
              && item['formKey'] === formConfigItem['key']);
          return !isEmpty(formConfigArray);
        }).map(content => set(get(content, 'data'), 'diagnosticOrderId', diagnosticOrder.id));
      }
    }
    let currentEvent$ = this._eventService.updateEvent(postEvent.id, postEvent, isEventSelected, true);
    let eventUpdates$: any = currentEvent$;
    if (previousSelectedEvent && get(this.config, 'maxEventSelection', 0) === 1) {
      previousSelectedEvent['selected'] = false;
      let previousEvent$ = this._eventService.updateEvent(previousSelectedEvent.id, previousSelectedEvent, false, true);
      eventUpdates$ = zip(
        currentEvent$,
        previousEvent$
        // getMultiValueObservable(), forkJoin on works for observables that complete
      ).pipe(
        map(([current, previous]) => {
          // forkJoin returns an array of values, here we map those values to an object
          return {current, previous};
        })
      );

    }
    eventUpdates$.pipe(
      takeUntil(this.destroyer.asObservable())
    ).subscribe(data => {
        this._store.dispatch({
          type: CORE_ACTIONS.SET_LOADER,
          payload: true
        });
        if(get(postEvent, 'selected')){
          this.mapEventToResources();
        } else {
          this._store.dispatch({
            type: CORE_ACTIONS.SET_LOADER,
            payload: false
          });
          this.notificationMessageService.success(this.notificationMessage.EVENT_DATA_UPDATED_SUCCESSFULLY);
        }
      },
      error => {
        this._store.dispatch({
          type: CORE_ACTIONS.SET_LOADER,
          payload: false
        });
        this.notificationMessageService.error(this.notificationMessage.FAILED_TO_UPDATE_EVENT_DATA);
      });
  }

  /**
   * prepare event content before calling update
   */
  prepareEventToUpdateFormData() {
    console.log("inside prepare method")
    this.flattenContent();
    if (!this.eventFormPayload) {
      return cloneDeep(this._selectedEvent);
    }
    const content: any = get(this._selectedEvent, 'content');

    /* const eventInfo = get(this.eventFormPayload.find(item => get(item, 'identifier') == 'eventinfo'), 'data');
     if (eventInfo) {
       set(this._selectedEvent, 'conclusion', get(eventInfo, 'conclusion'));
       set(this._selectedEvent, 'performed', get(eventInfo, 'performed'));
     }
     remove(this.eventFormPayload, {formKey: 'eventinfo'});*/
    remove(this.eventFormPayload, (data) =>  (data === null || data === undefined) );
    for (const data of this.eventFormPayload) {
      remove(content, item => {
        return get(item, 'contentType') !== 'file' && get(item, 'formKey') === get(data, 'formKey');
      });
    }
    // Remove attribute updatedField
    this.eventFormPayload.forEach((data, index) => {
      if (data['updatedFields']) {
        delete this.eventFormPayload[index]['updatedFields'];
      }
      //remove if data is empty
      if(isEmpty(get(data, 'data')) ||
        (get(data, `data.${get(data, 'formKey')}`) && isEmpty(get(data, `data.${get(data, 'formKey')}`)))) {
        this.eventFormPayload.splice(index, 1);
      }
    });
    content.push(...this.eventFormPayload);
    set(this._selectedEvent, 'content', content);

    delete this._selectedEvent['key'];
    delete this._selectedEvent['formId'];
    delete this._selectedEvent['file'];
    return cloneDeep(this._selectedEvent);
  }

  /**
   * This is event selection limit
   */
  verifyEventSelection(event) {
    if (event) {
      this._eventService.updateEvent(event.id, event).subscribe(data => {
        this.notificationMessageService.success(this.notificationMessage.EVENT_SELECTED_SUCCESSFULLY);
      });
    }
  }

  ngOnDestroy(): void {
    this.invokeSubs = null;
    this.selectedEvent = null;
    this.destroyer.next();
    this.destroyer.complete();
  }

}
